export const NAME = 'NAME' as const;
export const LAST_USED = 'LAST_USED' as const;
export const SCREENS_AND_CONTEXTS = 'SCREENS_AND_CONTEXTS' as const;
export const PROJECTS = 'PROJECTS' as const;
export const DELETED_ON = 'DELETED_ON' as const;
export const PERMANENTLY_DELETING = 'PERMANENTLY_DELETING' as const;
export const ACTIVE = 'Active' as const;
export const TRASHED = 'Trashed' as const;

export type SortField =
	| typeof NAME
	| typeof LAST_USED
	| typeof SCREENS_AND_CONTEXTS
	| typeof DELETED_ON
	| typeof PROJECTS
	| typeof PERMANENTLY_DELETING;

export type Filter = {
	page?: number;
	scope?: string;
	searchFilter?: string;
	sortField?: SortField | undefined | null;
	sortDirection?: 'ASC' | 'DESC' | undefined | null;
	customFieldStatus?: typeof ACTIVE | typeof TRASHED;
};
